import { render, staticRenderFns } from "./PortfolioChart.vue?vue&type=template&id=24d6140d&"
import script from "./PortfolioChart.vue?vue&type=script&lang=js&"
export * from "./PortfolioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports